import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    borderRadius: 8,
    width: '100%',
    boxShadow: `0px 0px 6px ${colors.neutral100}`,
    backgroundColor: colors.white,
    border: `1px solid ${colors.neutral100}`,
    '&:hover $topRight': {
      display: 'flex',
    },
  },
  titleWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  title: {
    lineHeight: '24px',
    fontWeight: 600,
    margin: 0,
  },
  subTitle: {
    lineHeight: '20px',
    fontWeight: 600,
    color: colors.neutral500,
  },
  description: {
    color: colors.neutral600,
    lineHeight: '24px',
  },
  cardTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    padding: 24,
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  topRight: {
    display: 'none',
    alignItems: 'center',
    gap: 16,
  },
  topLeft: {},
  btn: {
    minWidth: 'auto',
    height: 48,
    whiteSpace: 'nowrap',
    '& svg': {
      marginLeft: 10,
    },
  },
  badge: {
    borderRadius: 100,
    height: 28,
    fontSize: 14,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  badgeToday: {
    color: colors.white,
    border: 'none',
    backgroundColor: colors.textMisreported,
  },
  rating: {
    marginTop: 8,
    '& span': {
      color: colors.neutral900,
    },
    '& svg': {
      color: colors.warning500,
    },
  },
  cancelledStatusText: {
    whiteSpace: 'nowrap',
  },
});
